
import echarts from 'echarts'
import {unit_hash} from '../../fields'

export default {
    props: {
        item: {
            type: Object,
            default: () => ({})
        },
        index: {
            type: Number
        }
    },
    data() {
        this.echarts = null,
        this.params = null
        return {
            item_width: 270
        }
    },
    mounted() {
        this.echarts = echarts.init(this.$refs['item'], 'walden')
      
    },
    methods: {
        proxyupdateEcharts(params) {
            this.$nextTick(() => {
                if (!this.echarts) {
                    return 
                }
                this.echarts.resize({height:400})
                this.echarts.clear()
                this.echarts.setOption(params)
           })
        },
        changeSize({ 
            width, 
            unit, 
            x_labels = [], 
            values_hash = {},
            color = [],
            generateDataCall,
            title = '',
            seriesName = '',
            values = []
        }
            = {}
        ) {
            let _params = []
            _params = generateDataCall({
                title,
                unit_legend: unit_hash[unit], 
                unit, 
                x_labels, 
                values_hash, 
                color,
                seriesName,
                values,
            })

            this.item_width = width
            this.proxyupdateEcharts(_params)  
        }   
    },
    render() {
        const _this = this
        return <div style={{
            width: `${_this.item_width}px`,
           //  height: `${_this.item_width}px`,
            display: 'inline-block',
            padding: '0px 20px'
        }} ref="item">
            
        </div>
    }
}